module.exports = __webpack_public_path__ + "img/financialResult_2.91f92a77.png";